export const esCB = {
    landing: {
        recuperar_password: {
            instruccion_email:
                "Ingresa tu correo electrónico para recibir instrucciones de cómo restablecer tu contraseña."
        }
    }
}
